import { ManualDefinitionTableDataArray } from '@asset-metrix/portal-gateway-client-js';
import { SidebarDocument } from '@asset-metrix/portal-ui';

import { TableSidebarRowData } from './useTableSidebarProperties';

export function getFileDownloadColumnDocuments(
  data: TableSidebarRowData['data'] | undefined,
  fileDownloadColumnKeys: string[]
): ManualDefinitionTableDataArray {
  return fileDownloadColumnKeys
    .flatMap((key) => data?.[key])
    .filter(Boolean) as ManualDefinitionTableDataArray;
}

export function deduplicateDocumentsById(
  documents: SidebarDocument[]
): SidebarDocument[] {
  return documents.filter(
    (doc, index, array) => array.findIndex((d) => d.id === doc.id) === index
  );
}

export function resolveSidebarDocumentSelection(
  documents: SidebarDocument[],
  current: SidebarDocument | undefined
): SidebarDocument | undefined {
  if (documents.length === 0) {
    return undefined;
  }

  if (current != null) {
    const selectedDocument = documents.find(
      (document) => document.id === current.id
    );
    if (selectedDocument != null) {
      return selectedDocument;
    }
  }

  return documents[0];
}
